import { Injectable } from '@angular/core';
import { environment } from '#environment';

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  public logError(message: string, ...data: any) {
    if (!environment.debug) {
      return;
    }
    console.group(message);
    if (data && data.length > 0) {
      data.forEach((d) => console.error(d));
    }
    console.groupEnd();
  }

  public logMessage(message: string, ...data: any) {
    if (!environment.debug) {
      return;
    }
    console.groupCollapsed(message);
    if (data && data.length > 0) {
      data.forEach((d) => console.dir(d));
    }
    console.groupEnd();
  }
}
